/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'cross-flow-support.back-to-all-products': 'Voltar para todos os aplicativos',
  'cross-flow-support.close': 'Fechar',
  'cross-flow-support.product-store': 'Loja de apps',
};
